import React,{useEffect} from "react";
import * as S from './Searchpage.styles';
import ModifySearchHeaderUI from "./components/ModifySearchHeader/ModifySearchHeaderUI";
import Listing from './containers/Listing/Listing';
import Filter from '../../containers/Filter/Filter';
import LeadGenButton from "../SeoPage/containers/LeadGenButton/LeadGenButton";
import { useSelector,useDispatch } from "react-redux";
import {semFlowSelector,queryCBSelector} from './../../common/redux/selector';
import {fetchQueryFormData} from './../../common/redux/thunks';
import  {queryFieldsSelector} from './../SeoPage/redux/selector';
import { getLoadedComponent } from "../../config/omni";

const SearchPage = () => {
  const dispatch = useDispatch();
  const isSEMFlow = useSelector(semFlowSelector);
  const queryCB = useSelector(queryCBSelector)
  const queryFields = useSelector(queryFieldsSelector);

useEffect(()=>{
  getLoadedComponent('SearchPage')
  if(isSEMFlow){
    dispatch(fetchQueryFormData());
  }
},[])

  return (
    <S.Wrapper>
      <ModifySearchHeaderUI isSeo={false} />
      <S.PageWrapper>
        <S.PageLeft>
          <Filter />
        </S.PageLeft>
        <S.PageRight>
          <Listing />
        </S.PageRight>
      </S.PageWrapper>
     {queryCB && queryFields && queryFields.length ?  <LeadGenButton></LeadGenButton> :null}
    </S.Wrapper>
  );
};

export default SearchPage;

